import { useMemo } from 'react';
import Sheet from './Sheets';
import SheetContext from './SheetContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StyleSheetProvider({
  children
}) {
  const sheet = useMemo(() => {
    const s = document.createElement('style');
    document.head.appendChild(s);
    return new Sheet(s.sheet);
  }, []);
  return /*#__PURE__*/_jsx(SheetContext.Provider, {
    value: sheet,
    children: children
  });
}